var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L50 0L50 50L0 50L0 0Z",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DocOnline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.87485 42.5C1.87485 42.5 1.01054 47.2412 2.87502 47.8125C4.73951 48.3838 45.9793 48.1787 47.0624 47.8125C48.1455 47.4463 49.0991 42.5797 48.125 42.5C47.1508 42.4203 1.87485 42.5 1.87485 42.5Z",
    id: "New-shape",
    fill: "#07C180",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.12515 41.875C3.12515 41.875 2.51095 16.8248 3.12515 15C3.73935 13.1752 4.15161 12.6061 6.25025 12.5C8.34889 12.3938 42.6672 12.1372 43.4378 12.4999C44.2083 12.8626 46.4951 13.9342 46.875 15C47.2549 16.0658 46.875 41.875 46.875 41.875L3.12515 41.875Z",
    id: "New-shape-2",
    fill: "#07C180",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 15L43.75 15L43.75 38.125L6.875 38.125L6.875 15Z",
    id: "Rectangle-6",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 1.875L38.75 1.875L38.75 35L11.25 35L11.25 1.875Z",
    id: "Rectangle-7",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.125 42.4374L19.375 45L30 45L31.875 42.4374L18.125 42.4374Z",
    id: "New-shape-3",
    fill: "#FEFEFE",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Compu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L50 0L50 50L0 50L0 0Z",
    id: "Background",
    fill: "#FFFFFF",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4375 41.4063L47.6563 41.4063L47.6563 15.625C47.6535 13.4683 45.9059 11.7211 43.7496 11.7188L39.8437 11.7188L39.8437 1.5625C39.8437 1.13103 39.494 0.78125 39.0625 0.78125L10.9375 0.78125C10.506 0.78125 10.1563 1.13103 10.1563 1.5625L10.1563 11.7188L6.25 11.7188C4.09371 11.7213 2.34633 13.4687 2.34375 15.625L2.34375 41.4063L1.5625 41.4063C1.13103 41.4063 0.78125 41.756 0.78125 42.1875L0.78125 45.3125C0.784035 47.4692 2.53158 49.2164 4.68787 49.2188L45.3125 49.2188C47.4688 49.2162 49.2162 47.4688 49.2188 45.3125L49.2188 42.1875C49.2188 41.756 48.869 41.4063 48.4375 41.4063L48.4375 41.4063ZM11.7188 2.34375L38.2813 2.34375L38.2813 35.1563L11.7188 35.1563L11.7188 2.34375ZM3.90625 15.625C3.90625 14.3306 4.95558 13.2813 6.25 13.2813L10.1563 13.2813L10.1563 35.9375C10.1563 36.369 10.506 36.7188 10.9375 36.7188L39.0625 36.7188C39.494 36.7188 39.8438 36.369 39.8438 35.9375L39.8438 13.2813L43.75 13.2813C45.0444 13.2813 46.0938 14.3306 46.0938 15.625L46.0938 41.4063L3.90625 41.4063L3.90625 15.625ZM30.7672 42.9688L29.9859 44.5313L20.014 44.5313L19.2328 42.9688L30.7672 42.9688ZM47.6563 45.3125C47.6563 46.6069 46.6069 47.6563 45.3125 47.6563L4.6875 47.6563C3.39308 47.6563 2.34375 46.6069 2.34375 45.3125L2.34375 42.9688L17.4859 42.9688L18.832 45.6617C18.9644 45.9266 19.2351 46.0939 19.5313 46.0938L30.4687 46.0938C30.7663 46.0954 31.0389 45.9279 31.1719 45.6617L32.5141 42.9688L47.6563 42.9688L47.6563 45.3125Z",
    id: "Shape",
    fill: "#7A7A7A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.75 14.8438L40.6539 14.8438L40.6539 16.4063L42.9688 16.4063L42.9688 38.2813L7.03125 38.2813L7.03125 16.4063L9.40391 16.4063L9.40391 14.8438L6.25 14.8438C5.81853 14.8438 5.46875 15.1935 5.46875 15.625L5.46875 39.0625C5.46875 39.494 5.81853 39.8438 6.25 39.8438L43.75 39.8438C44.1815 39.8438 44.5313 39.494 44.5313 39.0625L44.5313 15.625C44.5313 15.1935 44.1815 14.8438 43.75 14.8438L43.75 14.8438Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 3.90625L14.0625 3.90625C13.631 3.90625 13.2813 4.25603 13.2813 4.6875L13.2813 7.8125C13.2813 8.24397 13.631 8.59375 14.0625 8.59375L17.1875 8.59375C17.619 8.59375 17.9688 8.24397 17.9688 7.8125L17.9688 4.6875C17.9688 4.25603 17.619 3.90625 17.1875 3.90625L17.1875 3.90625ZM16.4063 7.03125L14.8438 7.03125L14.8438 5.46875L16.4063 5.46875L16.4063 7.03125Z",
    id: "Shape",
    fill: "#7A7A7A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 10.1563L14.0625 10.1563C13.631 10.1563 13.2813 10.506 13.2813 10.9375L13.2813 14.0625C13.2813 14.494 13.631 14.8438 14.0625 14.8438L17.1875 14.8438C17.619 14.8438 17.9688 14.494 17.9688 14.0625L17.9688 10.9375C17.9688 10.506 17.619 10.1563 17.1875 10.1563L17.1875 10.1563ZM16.4063 13.2813L14.8438 13.2813L14.8438 11.7188L16.4063 11.7188L16.4063 13.2813Z",
    id: "Shape",
    fill: "#7A7A7A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 16.4063L14.0625 16.4063C13.631 16.4063 13.2813 16.756 13.2813 17.1875L13.2813 20.3125C13.2813 20.744 13.631 21.0938 14.0625 21.0938L17.1875 21.0938C17.619 21.0938 17.9688 20.744 17.9688 20.3125L17.9688 17.1875C17.9688 16.756 17.619 16.4063 17.1875 16.4063L17.1875 16.4063ZM16.4063 19.5313L14.8438 19.5313L14.8438 17.9688L16.4063 17.9688L16.4063 19.5313Z",
    id: "Shape",
    fill: "#7A7A7A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 22.6563L14.0625 22.6563C13.631 22.6563 13.2813 23.006 13.2813 23.4375L13.2813 26.5625C13.2813 26.994 13.631 27.3438 14.0625 27.3438L17.1875 27.3438C17.619 27.3438 17.9688 26.994 17.9688 26.5625L17.9688 23.4375C17.9688 23.006 17.619 22.6563 17.1875 22.6563L17.1875 22.6563ZM16.4063 25.7813L14.8438 25.7813L14.8438 24.2188L16.4063 24.2188L16.4063 25.7813Z",
    id: "Shape",
    fill: "#7A7A7A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5313 3.90625L36.7188 3.90625L36.7188 5.46875L19.5313 5.46875L19.5313 3.90625Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5313 7.03125L33.5938 7.03125L33.5938 8.59375L19.5313 8.59375L19.5313 7.03125Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1563 7.03125L36.7188 7.03125L36.7188 8.59375L35.1563 8.59375L35.1563 7.03125Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5313 10.1563L36.7188 10.1563L36.7188 11.7188L19.5313 11.7188L19.5313 10.1563Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5313 13.2813L33.5938 13.2813L33.5938 14.8438L19.5313 14.8438L19.5313 13.2813Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1563 13.2813L36.7188 13.2813L36.7188 14.8438L35.1563 14.8438L35.1563 13.2813Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5313 16.4063L36.7188 16.4063L36.7188 17.9688L19.5313 17.9688L19.5313 16.4063Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5313 19.5313L33.5938 19.5313L33.5938 21.0938L19.5313 21.0938L19.5313 19.5313Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1563 19.5313L36.7188 19.5313L36.7188 21.0938L35.1563 21.0938L35.1563 19.5313Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5313 22.6563L36.7188 22.6563L36.7188 24.2188L19.5313 24.2188L19.5313 22.6563Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5313 25.7813L33.5938 25.7813L33.5938 27.3438L19.5313 27.3438L19.5313 25.7813Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1563 25.7813L36.7188 25.7813L36.7188 27.3438L35.1563 27.3438L35.1563 25.7813Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 28.9063L14.0625 28.9063C13.631 28.9063 13.2813 29.256 13.2813 29.6875L13.2813 32.8125C13.2813 33.244 13.631 33.5938 14.0625 33.5938L17.1875 33.5938C17.619 33.5938 17.9688 33.244 17.9688 32.8125L17.9688 29.6875C17.9688 29.256 17.619 28.9063 17.1875 28.9063L17.1875 28.9063ZM16.4063 32.0313L14.8438 32.0313L14.8438 30.4688L16.4063 30.4688L16.4063 32.0313Z",
    id: "Shape",
    fill: "#7A7A7A",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5313 28.9063L36.7188 28.9063L36.7188 30.4688L19.5313 30.4688L19.5313 28.9063Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5313 32.0313L33.5938 32.0313L33.5938 33.5938L19.5313 33.5938L19.5313 32.0313Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1563 32.0313L36.7188 32.0313L36.7188 33.5938L35.1563 33.5938L35.1563 32.0313Z",
    id: "Shape",
    fill: "#7A7A7A",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopExcel);
export default __webpack_public_path__ + "static/media/laptopExcel.ca079a9f3dc884d6d642ecd17c6e8db7.svg";
export { ForwardRef as ReactComponent };